import ValueInput from 'dashboard/apps/DashboardLayoutEditor/CaseConditionalLogicEditor/ValueInput';
import CaseDataManagerSchemaSelect from 'dashboard/components/CaseDataManagerSchemaSelect';
import { ConditionalRuleValueTypes, RuleValueTypes } from 'dashboard/lib/workflows';
import { JsonSchema } from 'lib/json-schema';
import { assertNever } from 'lib/utils/types';

interface FieldOrValueInputProps {
  configType: ConditionalRuleValueTypes;
  jsonSchema: JsonSchema;
  formattedValue: string | string[];
  onChange: (value: any) => void;
  disabled?: boolean;
  fieldSchema: JsonSchema;
  isMulti: boolean;
  hasError: boolean;
}

const FieldOrValueInput = ({
  configType,
  jsonSchema,
  fieldSchema,
  formattedValue,
  isMulti,
  hasError,
  onChange,
  disabled = false,
}: FieldOrValueInputProps) => {
  switch (configType) {
    case RuleValueTypes.Value: {
      return (
        <ValueInput
          fieldSchema={fieldSchema}
          formattedValue={formattedValue}
          isMulti={isMulti}
          disabled={disabled}
          onChange={onChange}
          hasError={hasError}
        />
      );
    }
    case RuleValueTypes.Field: {
      return (
        <CaseDataManagerSchemaSelect
          id='edit-rule-input-possibilities__right-field'
          jsonSchema={jsonSchema}
          inputValue={formattedValue.toString()}
          onValueChange={onChange}
          disabled={disabled}
          hasError={hasError}
          portal
        />
      );
    }
    default:
      assertNever(configType);
  }
};

export default FieldOrValueInput;
